import BannerModule from './containers/bannerModule'

export {default as BannerModuleLayout} from './components/bannerModuleLayout'

export default BannerModule
